import React from 'react';
import { autobind } from 'core-decorators';
import BasePage from 'components/BasePage';
import { FlexColContainer } from 'components/StyledComp';
import TablePatients from './components/TablePatients';

const propTypes = {
};

@autobind
class PatientsPage extends BasePage {
  constructor(props) {
    super(props);

    this.state = {
      tableKey: null,
      patients: null,
      patientContracts: null,
    };
  }

  componentDidMount() {
    this.type = this.parseQueryParam('type', this.props.location) || 'PROCESSING';
    this.getPatients();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      // Empty original lists.
      this.setState({
        patients: null,
        patientContracts: null,
      }, () => {
        this.type = this.parseQueryParam('type', this.props.location) || 'PROCESSING';
        this.getPatients();
      });
    }
  }

  getTitle() {
    return 'Patients';
  }

  async getPatients() {
    const patients = this.type === 'PROCESSING'
      ? await this.callServiceForRemoteObjects('/patient/get_processing_patients')
      : await this.callServiceForRemoteObjects('/patient/get_all_patients');

    // Also get the latest contract for each patient.
    const params = {
      patientIds: patients.map((p) => p.getId()),
    };
    const patientContracts =
        await this.callServiceForRemoteObjects('/contract/get_latest_active_for_patients', params);

    this.setState({
      tableKey: `${Date.now()}_${Math.random()}`,
      patients,
      patientContracts,
    });
  }

  isInRenderableState() {
    return !!this.state.patients && !!this.state.patientContracts;
  }

  renderContent() {
    const { tableKey, patients, patientContracts } = this.state;

    const tableTitle = this.type === 'PROCESSING' ? 'Patients to be processed' : 'All Patients';

    return (
      <FlexColContainer
        width="match_parent"
        height="wrap_content"
        alignItems="center"
      >
        <TablePatients
          key={tableKey}
          width="match_parent"
          height="wrap_content"
          margin="0 0 24px 0"
          title={tableTitle}
          patients={patients}
          patientContracts={patientContracts}
        />
      </FlexColContainer>
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
PatientsPage.propTypes = propTypes;

export default PatientsPage;
